<h1>Du skal være logget ind for at tilgå denne side</h1>

<button (click)="authService.login()" mat-flat-button color="primary" class="margin--left-auto btn-icon" type="button">
  <svg class="icon-24">
    <use href="assets/images/ok-icons-sprite.svg#user-s"></use>
  </svg>
  <span>Log ind nu</span>
</button>
